import { Injectable, Injector } from '@angular/core';

import { Observable, of } from 'rxjs';
import { concatMap } from 'rxjs/operators';

import { DecisionModelService } from '../../services';

import { DECISION_MODEL_STATE_ENUMERATION, DECISION_MODEL_STEPS_CONSTANTS, redirectDecisionModel } from '../../configs';

import { WorkflowStepType, WorkflowStepResultType } from '../../models';

@Injectable({ providedIn: 'root' })
export class InitialStep implements WorkflowStepType {
  constructor(private readonly decisionModelService: DecisionModelService) {}

  public execute(injector: Injector): Observable<WorkflowStepResultType> {
    return this.decisionModelService.initialValidations().pipe(
      concatMap((response) => {
        if (response?.processState === DECISION_MODEL_STATE_ENUMERATION.APPROVED) {
          return of({ success: true, nextStep: DECISION_MODEL_STEPS_CONSTANTS.DECISION_STEP });
        }

        redirectDecisionModel({ state: response?.processState, injector });
        return of({ success: false });
      })
    );
  }
}
